"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchTrigger = void 0;
var BatchTrigger;
(function (BatchTrigger) {
    BatchTrigger["MANUAL"] = "manual";
    BatchTrigger["WEBHOOK"] = "webhook";
    BatchTrigger["UPLOAD"] = "upload";
    BatchTrigger["API"] = "api";
    BatchTrigger["RECOVERY"] = "recovery";
})(BatchTrigger = exports.BatchTrigger || (exports.BatchTrigger = {}));
